import { YYYY_MM_DD } from '../../locale/consts/date-format';
import { dateFormat, isNil, Nillable } from '@web/utils';

export const dateSerializer = (format: string = YYYY_MM_DD) => {
  return (value: Nillable<Date>): string | null => {
    if (isNil(value)) {
      return null;
    }

    return dateFormat(value, format);
  };
};
